import { render, staticRenderFns } from "./QType7Answer.vue?vue&type=template&id=4a0833b0&scoped=true&"
import script from "./QType7Answer.vue?vue&type=script&lang=js&"
export * from "./QType7Answer.vue?vue&type=script&lang=js&"
import style0 from "./QType7Answer.vue?vue&type=style&index=0&id=4a0833b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0833b0",
  null
  
)

export default component.exports